export type DebounceFunction = (...args: any[]) => void;

export const useDebounceFn = (func: DebounceFunction, delay: number): DebounceFunction => {
  let timer: NodeJS.Timeout;

  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      /* eslint-disable-next-line */
      func.apply(null, args);
    }, delay);
  };
};
